var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found container"},[_c('h1',[_vm._v("404 page not found")]),_c('p',[_c('bButton',{staticClass:"mt-4",attrs:{"to":"/","variant":"primary"}},[_vm._v("return to start page")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }